import { buildLegacyRpcSdk } from "@daytrip/legacy-rpc-sdk-browser";

import { LEGACY_RPC_URL, REVISION, VERSION } from "./config.management";
import { getAuthenticationStore } from "./domain/authentication/AuthenticationStore.singleton";
import { getAuthenticationTokensOrFail } from "./domain/authentication/utils/getAuthenticationTokensOrFail";
import {
    setManagementAuthenticationToken,
    setManagementRefreshToken,
} from "./utils/authentication/authenticationUtils";

export type RpcClient = ReturnType<typeof buildLegacyRpcSdk>;
let rpcClient: RpcClient | null = null;

function initRpcClient() {
    return buildLegacyRpcSdk({
        rpcEndpoint: LEGACY_RPC_URL,
        clientName: "management",
        clientRevision: REVISION,
        clientVersion: VERSION,
        tokensRefreshedCallback(tokenPair, bothTokens?) {
            setManagementAuthenticationToken(tokenPair.authentication);
            if (bothTokens) {
                setManagementRefreshToken(tokenPair.refresh);
            }

            getAuthenticationStore().setAuthenticationToken(tokenPair.authentication);
        },
        refreshTokenExpiredCallback() {
            getAuthenticationStore().logout(true);
        },
        tokensProvider() {
            return getAuthenticationTokensOrFail();
        },
    });
}

export function getRpcClient() {
    if (!rpcClient) {
        rpcClient = initRpcClient();
    }

    return rpcClient;
}
